/* ╔══════════════════════════════════════════════════════════════╗
   ║  cdm-onboarding.js — v4 (rewrite complet, IIFE classique)    ║
   ║  CDM by Nawhal's — animation déblocage premier joueur        ║
   ╚══════════════════════════════════════════════════════════════╝

   Flow :
     1. Formulaire d'inscription (Prénom, Nom, Pays, Email)
     2. Animation booster — 4 clics sur la capsule
     3. Reveal mascotte + confetti
     4. CTA "COMMENCER À JOUER" → onComplete(teamId)

   Exposition : window.cdmOnboarding(opts)
*/

(function () {
  'use strict';

  console.log('[CDM-OB] Script chargé');

  /* ── Équipes ── */
  var TEAMS = [
    { id: 'france',     name: 'FRANCE',        label: 'France',        colors: ['#002395','#FFFFFF','#ED2939'] },
    { id: 'algerie',    name: 'ALGÉRIE',       label: 'Algérie',       colors: ['#006233','#FFFFFF','#D21034'] },
    { id: 'maroc',      name: 'MAROC',         label: 'Maroc',         colors: ['#C1272D','#006233','#FFFFFF'] },
    { id: 'bresil',     name: 'BRÉSIL',        label: 'Brésil',        colors: ['#009C3B','#FFDF00','#002776'] },
    { id: 'espagne',    name: 'ESPAGNE',       label: 'Espagne',       colors: ['#AA151B','#F1BF00','#AA151B'] },
    { id: 'allemagne',  name: 'ALLEMAGNE',     label: 'Allemagne',     colors: ['#1A1A1A','#DD0000','#FFCE00'] },
    { id: 'angleterre', name: 'ANGLETERRE',    label: 'Angleterre',    colors: ['#CF142B','#FFFFFF','#CF142B'] },
    { id: 'belgique',   name: 'BELGIQUE',      label: 'Belgique',      colors: ['#1A1A1A','#FAE042','#EF3340'] },
    { id: 'senegal',    name: 'SÉNÉGAL',       label: 'Sénégal',       colors: ['#00853F','#FDEF42','#E31B23'] },
    { id: 'tunisie',    name: 'TUNISIE',       label: 'Tunisie',       colors: ['#E70013','#FFFFFF','#E70013'] },
    { id: 'turquie',    name: 'TURQUIE',       label: 'Turquie',       colors: ['#E30A17','#FFFFFF','#E30A17'] },
    { id: 'japon',      name: 'JAPON',         label: 'Japon',         colors: ['#BC002D','#FFFFFF','#BC002D'] },
    { id: 'usa',        name: 'USA',           label: 'USA',           colors: ['#B22234','#FFFFFF','#3C3B6E'] },
    { id: 'coteivoire', name: "CÔTE D'IVOIRE", label: "Côte d'Ivoire", colors: ['#F77F00','#FFFFFF','#009A44'] },
  ];

  /* ── Drapeaux SVG (viewBox 38×28) ── */
  var FLAGS = {
    'FRANCE':       '<rect width="12.7" height="28" fill="#002395"/><rect x="12.7" width="12.6" height="28" fill="#fff"/><rect x="25.3" width="12.7" height="28" fill="#ed2939"/>',
    'ALGÉRIE':      '<rect width="38" height="28" fill="#fff"/><rect width="19" height="28" fill="#006233"/><circle cx="21" cy="14" r="6.5" fill="#d21034"/><circle cx="23.5" cy="14" r="5.3" fill="#fff"/>',
    'MAROC':        '<rect width="38" height="28" fill="#c1272d"/><path d="M19,8.5 L22.2,18.4 L13.8,12.3 L24.2,12.3 L15.8,18.4 Z" fill="none" stroke="#006233" stroke-width="1.3"/>',
    'BRÉSIL':       '<rect width="38" height="28" fill="#009c3b"/><polygon points="19,2.5 35.5,14 19,25.5 2.5,14" fill="#ffdf00"/><circle cx="19" cy="14" r="5.8" fill="#002776"/>',
    'ESPAGNE':      '<rect width="38" height="28" fill="#c60b1e"/><rect y="7" width="38" height="14" fill="#ffc400"/>',
    'ALLEMAGNE':    '<rect width="38" height="9.3" fill="#000"/><rect y="9.3" width="38" height="9.4" fill="#d00"/><rect y="18.7" width="38" height="9.3" fill="#ffce00"/>',
    'ANGLETERRE':   '<rect width="38" height="28" fill="#fff"/><rect x="15" width="8" height="28" fill="#cf142b"/><rect y="10" width="38" height="8" fill="#cf142b"/>',
    'BELGIQUE':     '<rect width="12.7" height="28" fill="#000"/><rect x="12.7" width="12.6" height="28" fill="#fae042"/><rect x="25.3" width="12.7" height="28" fill="#ef3340"/>',
    'SÉNÉGAL':      '<rect width="12.7" height="28" fill="#00853f"/><rect x="12.7" width="12.6" height="28" fill="#fdef42"/><rect x="25.3" width="12.7" height="28" fill="#e31b23"/>',
    'TUNISIE':      '<rect width="38" height="28" fill="#e70013"/><circle cx="19" cy="14" r="7" fill="#fff"/><circle cx="21.5" cy="14" r="5.5" fill="#e70013"/>',
    'TURQUIE':      '<rect width="38" height="28" fill="#e30a17"/><circle cx="17" cy="14" r="6.5" fill="#fff"/><circle cx="19.5" cy="14" r="5.3" fill="#e30a17"/>',
    'JAPON':        '<rect width="38" height="28" fill="#fff"/><circle cx="19" cy="14" r="8" fill="#bc002d"/>',
    'USA':          '<rect width="38" height="28" fill="#b22234"/><rect y="4.3" width="38" height="4.3" fill="#fff"/><rect y="12.9" width="38" height="4.3" fill="#fff"/><rect y="21.5" width="38" height="4.3" fill="#fff"/><rect width="15.2" height="15.1" fill="#3c3b6e"/>',
    "CÔTE D'IVOIRE":'<rect width="12.7" height="28" fill="#f77f00"/><rect x="12.7" width="12.6" height="28" fill="#fff"/><rect x="25.3" width="12.7" height="28" fill="#009a44"/>',
  };

  /* ══════════════════════════════════════════
     INJECTION CSS (keyframes uniquement — tout le reste est inline)
  ══════════════════════════════════════════ */
  function injectKeyframes() {
    if (document.getElementById('cdm-ob-kf')) return;
    var s = document.createElement('style');
    s.id = 'cdm-ob-kf';
    s.textContent =
      '@keyframes cdmObFadeIn { from { opacity: 0 } to { opacity: 1 } }' +
      '@keyframes cdmObPopIn { from { transform: scale(.85); opacity: 0 } to { transform: scale(1); opacity: 1 } }' +
      '@keyframes cdmObBob { 0%,100% { transform: translateY(0) } 50% { transform: translateY(-10px) } }' +
      '@keyframes cdmObShake { 0%,100% { transform: translate(0,0) rotate(0) } 20% { transform: translate(-8px,3px) rotate(-3deg) } 40% { transform: translate(7px,-2px) rotate(2.5deg) } 60% { transform: translate(-6px,2px) rotate(-2deg) } 80% { transform: translate(4px,-1px) rotate(1.5deg) } }' +
      '@keyframes cdmObPulse { 0%,100% { box-shadow: 0 0 30px rgba(255,188,39,.4) } 50% { box-shadow: 0 0 50px rgba(255,188,39,.8) } }' +
      '@keyframes cdmObFlash { 0% { opacity: 0; transform: scale(.2) } 50% { opacity: 1; transform: scale(1.2) } 100% { opacity: 0; transform: scale(2.5) } }' +
      '@keyframes cdmObReveal { 0% { opacity: 0; transform: translateY(80px) scale(.4) } 50% { opacity: 1; transform: translateY(-20px) scale(1.15) } 75% { transform: translateY(8px) scale(.97) } 100% { opacity: 1; transform: translateY(0) scale(1) } }';
    document.head.appendChild(s);
    console.log('[CDM-OB] Keyframes injectées');
  }

  /* ══════════════════════════════════════════
     FORMULAIRE D'INSCRIPTION
  ══════════════════════════════════════════ */
  function createForm(onSubmit) {
    console.log('[CDM-OB] Création formulaire…');

    var ov = document.createElement('div');
    ov.id = 'cdm-ob-form';
    ov.style.cssText =
      'position:fixed!important;' +
      'top:0!important;left:0!important;right:0!important;bottom:0!important;' +
      'z-index:2147483600!important;' +
      'display:flex!important;align-items:center!important;justify-content:center!important;' +
      'padding:20px!important;' +
      'background:rgba(6,15,28,.92)!important;' +
      'backdrop-filter:blur(14px);' +
      '-webkit-backdrop-filter:blur(14px);' +
      'font-family:Nunito,Trebuchet MS,Arial,sans-serif!important;' +
      'animation:cdmObFadeIn .3s ease forwards;';

    ov.innerHTML =
      '<div style="' +
        'width:min(92vw,380px);max-height:90vh;overflow:auto;' +
        'background:linear-gradient(165deg,#0e1e30,#07121d);' +
        'border:2px solid rgba(245,197,24,.5);border-radius:24px;' +
        'padding:26px 22px 22px;' +
        'box-shadow:0 24px 60px rgba(0,0,0,.8),0 0 50px rgba(245,197,24,.2);' +
        'animation:cdmObPopIn .4s cubic-bezier(.16,1,.3,1) forwards;' +
      '">' +
        '<div style="font-size:1.2rem;font-weight:900;color:#fff;text-align:center;margin-bottom:4px">🎮 Crée ton profil joueur</div>' +
        '<div style="font-size:.62rem;color:rgba(255,255,255,.55);text-align:center;letter-spacing:.08em;margin-bottom:18px;text-transform:uppercase">Pour débloquer ton premier joueur</div>' +

        '<div style="display:flex;gap:10px;margin-bottom:12px">' +
          '<div style="flex:1">' +
            '<label style="display:block;font-size:.6rem;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#f5c518;margin-bottom:5px">Prénom</label>' +
            '<input id="cdm-fld-prenom" type="text" autocomplete="given-name" placeholder="Ton prénom" ' +
              'style="width:100%;box-sizing:border-box;background:rgba(255,255,255,.08);border:1.5px solid rgba(245,197,24,.25);' +
              'border-radius:12px;padding:11px 13px;color:#fff;font-family:inherit;font-size:.92rem;outline:none;-webkit-appearance:none">' +
          '</div>' +
          '<div style="flex:1">' +
            '<label style="display:block;font-size:.6rem;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#f5c518;margin-bottom:5px">Nom</label>' +
            '<input id="cdm-fld-nom" type="text" autocomplete="family-name" placeholder="Ton nom" ' +
              'style="width:100%;box-sizing:border-box;background:rgba(255,255,255,.08);border:1.5px solid rgba(245,197,24,.25);' +
              'border-radius:12px;padding:11px 13px;color:#fff;font-family:inherit;font-size:.92rem;outline:none;-webkit-appearance:none">' +
          '</div>' +
        '</div>' +

        '<div style="margin-bottom:12px">' +
          '<label style="display:block;font-size:.6rem;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#f5c518;margin-bottom:5px">Pays</label>' +
          '<input id="cdm-fld-pays" type="text" autocomplete="country-name" placeholder="Ton pays" ' +
            'style="width:100%;box-sizing:border-box;background:rgba(255,255,255,.08);border:1.5px solid rgba(245,197,24,.25);' +
            'border-radius:12px;padding:11px 13px;color:#fff;font-family:inherit;font-size:.92rem;outline:none;-webkit-appearance:none">' +
        '</div>' +

        '<div style="margin-bottom:12px">' +
          '<label style="display:block;font-size:.6rem;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#f5c518;margin-bottom:5px">Adresse email</label>' +
          '<input id="cdm-fld-email" type="email" autocomplete="email" placeholder="ton@email.com" ' +
            'style="width:100%;box-sizing:border-box;background:rgba(255,255,255,.08);border:1.5px solid rgba(245,197,24,.25);' +
            'border-radius:12px;padding:11px 13px;color:#fff;font-family:inherit;font-size:.92rem;outline:none;-webkit-appearance:none">' +
        '</div>' +

        '<div id="cdm-fld-err" style="font-size:.65rem;color:#ff6b6b;text-align:center;min-height:18px;margin:2px 0 8px;font-weight:700"></div>' +

        '<button id="cdm-fld-submit" type="button" style="' +
          'width:100%;height:54px;' +
          'background:linear-gradient(175deg,#ffe040 0%,#f5c518 35%,#d97800 100%);' +
          'border:3px solid #4a1e00;border-radius:16px;' +
          'color:#fff;font-family:inherit;font-size:.98rem;font-weight:900;' +
          'letter-spacing:.06em;text-transform:uppercase;text-shadow:0 2px 0 #4a1e00;' +
          'box-shadow:0 10px 26px rgba(0,0,0,.5),0 0 22px rgba(245,197,24,.25);' +
          'cursor:pointer;' +
        '">OUVRIR MON PACK ⚽</button>' +
      '</div>';

    document.body.appendChild(ov);
    console.log('[CDM-OB] Formulaire ajouté au DOM, id =', ov.id);

    var btn = ov.querySelector('#cdm-fld-submit');
    var err = ov.querySelector('#cdm-fld-err');

    btn.addEventListener('click', function () {
      var prenom = ov.querySelector('#cdm-fld-prenom').value.trim();
      var nom    = ov.querySelector('#cdm-fld-nom').value.trim();
      var pays   = ov.querySelector('#cdm-fld-pays').value.trim();
      var email  = ov.querySelector('#cdm-fld-email').value.trim();

      if (!prenom || !nom || !email) {
        err.textContent = 'Veuillez remplir Prénom, Nom et Email.';
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        err.textContent = 'Adresse email invalide.';
        return;
      }
      err.textContent = '';

      try {
        localStorage.setItem('cdm_player', JSON.stringify({ prenom: prenom, nom: nom, pays: pays, email: email }));
      } catch (_) {}

      console.log('[CDM-OB] Formulaire soumis');
      ov.style.transition = 'opacity .25s ease';
      ov.style.opacity = '0';
      setTimeout(function () { ov.remove(); onSubmit(); }, 280);
    });
  }

  /* ══════════════════════════════════════════
     ANIMATION BOOSTER (4 clics → reveal)
  ══════════════════════════════════════════ */
  function createBooster(team, capsuleUrl, unlockBgUrl, onComplete) {
    console.log('[CDM-OB] Création booster pour', team.id);

    var ov = document.createElement('div');
    ov.id = 'cdm-ob-booster';
    ov.style.cssText =
      'position:fixed!important;' +
      'top:0!important;left:0!important;right:0!important;bottom:0!important;' +
      'z-index:2147483601!important;' +
      'display:flex!important;flex-direction:column!important;' +
      'align-items:center!important;justify-content:center!important;' +
      'background:radial-gradient(circle at 50% 30%,#fff4d6 0%,#f7c97e 50%,#d97800 100%)!important;' +
      'overflow:hidden!important;' +
      'font-family:Nunito,Trebuchet MS,Arial,sans-serif!important;' +
      'animation:cdmObFadeIn .35s ease forwards;';

    var capsuleImg = capsuleUrl
      ? '<img src="' + capsuleUrl + '" alt="" style="width:100%;height:100%;object-fit:contain;user-select:none;-webkit-user-drag:none;pointer-events:none;filter:drop-shadow(0 20px 30px rgba(124,72,0,.4))">'
      : '<div style="font-size:8rem">🎁</div>';

    ov.innerHTML =
      /* Bouton PASSER */
      '<button id="cdm-skip" type="button" style="' +
        'position:absolute;top:14px;right:14px;z-index:10;' +
        'padding:8px 16px;border-radius:999px;' +
        'background:rgba(0,0,0,.35);border:1px solid rgba(255,255,255,.4);' +
        'color:#fff;font-family:inherit;font-size:.66rem;font-weight:800;' +
        'letter-spacing:.1em;text-transform:uppercase;cursor:pointer' +
      '">PASSER ↗</button>' +

      /* Capsule cliquable */
      '<div id="cdm-capsule-wrap" style="' +
        'position:relative;width:min(70vw,280px);aspect-ratio:1/1.5;' +
        'cursor:pointer;user-select:none;-webkit-user-select:none;' +
        'animation:cdmObBob 3s ease-in-out infinite;' +
        'display:flex;align-items:center;justify-content:center;' +
      '">' +
        '<div id="cdm-capsule-inner" style="width:100%;height:100%;display:flex;align-items:center;justify-content:center">' +
          capsuleImg +
        '</div>' +
      '</div>' +

      /* Hint */
      '<div id="cdm-hint" style="' +
        'margin-top:30px;text-align:center;' +
      '">' +
        '<div style="font-size:.68rem;font-weight:900;letter-spacing:.18em;text-transform:uppercase;color:#7a4500;margin-bottom:10px">Touche pour ouvrir</div>' +
        '<div id="cdm-pips" style="display:flex;gap:10px;justify-content:center">' +
          '<span class="cdm-pip" style="width:14px;height:14px;border-radius:50%;background:rgba(122,69,0,.2);border:2px solid #7a4500;transition:background .2s"></span>' +
          '<span class="cdm-pip" style="width:14px;height:14px;border-radius:50%;background:rgba(122,69,0,.2);border:2px solid #7a4500;transition:background .2s"></span>' +
          '<span class="cdm-pip" style="width:14px;height:14px;border-radius:50%;background:rgba(122,69,0,.2);border:2px solid #7a4500;transition:background .2s"></span>' +
          '<span class="cdm-pip" style="width:14px;height:14px;border-radius:50%;background:rgba(122,69,0,.2);border:2px solid #7a4500;transition:background .2s"></span>' +
        '</div>' +
      '</div>' +

      /* Flash overlay (caché par défaut) */
      '<div id="cdm-flash" style="' +
        'position:absolute;inset:0;pointer-events:none;' +
        'background:radial-gradient(circle,#fff,#ffd680 40%,transparent 70%);' +
        'opacity:0;z-index:5;' +
      '"></div>' +

      /* Reveal screen (caché par défaut) */
      '<div id="cdm-reveal" style="' +
        'position:absolute;inset:0;z-index:8;' +
        'display:none;flex-direction:column;align-items:center;justify-content:center;' +
        'background:#060f1c;padding:24px;' +
      '">' +
        '<div style="font-size:.72rem;font-weight:900;letter-spacing:.3em;text-transform:uppercase;color:#ffca4a;text-shadow:0 0 20px rgba(255,180,30,.8);margin-bottom:6px">★ Nouveau Joueur ★</div>' +
        '<div style="font-size:clamp(2.2rem,11vw,4.5rem);font-weight:900;text-transform:uppercase;line-height:.9;color:#fff8dc;text-shadow:0 0 28px rgba(255,215,74,1),0 3px 0 rgba(185,115,0,.9),0 14px 30px rgba(0,0,0,.6);margin-bottom:30px;text-align:center">Débloqué !</div>' +
        '<img id="cdm-mascot" alt="" style="' +
          'width:min(60vw,260px);height:auto;max-height:42vh;object-fit:contain;' +
          'filter:drop-shadow(0 0 40px rgba(255,200,80,.7)) drop-shadow(0 20px 30px rgba(0,0,0,.55));' +
          'animation:cdmObReveal 1.1s cubic-bezier(.16,1,.3,1) forwards;' +
          'opacity:0;' +
        '">' +
        '<div style="margin-top:24px;display:flex;flex-direction:column;align-items:center;gap:8px">' +
          '<svg id="cdm-flag" viewBox="0 0 38 28" xmlns="http://www.w3.org/2000/svg" style="width:56px;height:42px;border-radius:6px;border:2px solid rgba(255,202,74,.5);box-shadow:0 0 14px rgba(255,180,30,.4);overflow:hidden"></svg>' +
          '<div id="cdm-country-name" style="background:linear-gradient(175deg,#18304e,#0d1f35);border:1.5px solid rgba(255,202,74,.5);border-radius:14px;padding:12px 28px;color:#fff7ea;font-weight:900;text-transform:uppercase;letter-spacing:.1em;font-size:clamp(.95rem,3vw,1.3rem);min-width:160px;text-align:center;box-shadow:0 14px 40px rgba(0,0,0,.6)">—</div>' +
        '</div>' +
        '<button id="cdm-cta" type="button" style="' +
          'margin-top:36px;width:min(88%,320px);height:56px;' +
          'background:linear-gradient(175deg,#ffe040 0%,#f5c518 35%,#d97800 100%);' +
          'border:3px solid #4a1e00;border-radius:18px;' +
          'color:#fff;font-family:inherit;font-size:1.02rem;font-weight:900;' +
          'letter-spacing:.06em;text-transform:uppercase;text-shadow:0 2px 0 #4a1e00;' +
          'box-shadow:0 14px 36px rgba(0,0,0,.55),0 0 28px rgba(245,197,24,.35);' +
          'cursor:pointer;' +
        '">COMMENCER À JOUER 🏆</button>' +
      '</div>' +

      /* Confetti canvas */
      '<canvas id="cdm-confetti" style="position:absolute;inset:0;pointer-events:none;z-index:9;opacity:0;transition:opacity .25s"></canvas>';

    document.body.appendChild(ov);
    console.log('[CDM-OB] Booster ajouté au DOM');

    var capsuleWrap = ov.querySelector('#cdm-capsule-wrap');
    var capsuleInner = ov.querySelector('#cdm-capsule-inner');
    var pips        = ov.querySelectorAll('.cdm-pip');
    var hint        = ov.querySelector('#cdm-hint');
    var flash       = ov.querySelector('#cdm-flash');
    var reveal      = ov.querySelector('#cdm-reveal');
    var mascot      = ov.querySelector('#cdm-mascot');
    var flag        = ov.querySelector('#cdm-flag');
    var countryName = ov.querySelector('#cdm-country-name');
    var cta         = ov.querySelector('#cdm-cta');
    var skip        = ov.querySelector('#cdm-skip');
    var canvas      = ov.querySelector('#cdm-confetti');
    var ctx         = canvas.getContext('2d');

    var clicks = 0, busy = false, done = false, rafId = null;

    function complete() {
      console.log('[CDM-OB] Booster terminé');
      try { localStorage.setItem('cdm_onboarded', '1'); } catch (_) {}
      try { localStorage.setItem('cdm_team', team.id); } catch (_) {}
      if (rafId) cancelAnimationFrame(rafId);
      ov.style.transition = 'opacity .4s ease';
      ov.style.opacity = '0';
      setTimeout(function () {
        ov.remove();
        if (typeof onComplete === 'function') onComplete(team.id);
      }, 420);
    }

    function spawnConfetti() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      canvas.style.opacity = '1';
      var particles = [];
      for (var i = 0; i < 220; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: -20 - Math.random() * canvas.height * 0.5,
          w: 6 + Math.random() * 8,
          h: 4 + Math.random() * 6,
          r: Math.random() * Math.PI * 2,
          dr: (Math.random() - 0.5) * 0.25,
          vx: (Math.random() - 0.5) * 5,
          vy: 2 + Math.random() * 5,
          g: 0.08 + Math.random() * 0.07,
          color: team.colors[Math.floor(Math.random() * team.colors.length)],
          alpha: 1,
        });
      }
      function loop() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        var alive = false;
        for (var i = 0; i < particles.length; i++) {
          var p = particles[i];
          p.vy += p.g; p.x += p.vx; p.y += p.vy; p.r += p.dr;
          if (p.y > canvas.height * 0.75) p.alpha -= 0.02;
          if (p.alpha <= 0) continue;
          alive = true;
          ctx.save();
          ctx.globalAlpha = Math.max(0, p.alpha);
          ctx.translate(p.x, p.y);
          ctx.rotate(p.r);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          ctx.restore();
        }
        if (alive) rafId = requestAnimationFrame(loop);
      }
      loop();
    }

    function doReveal() {
      console.log('[CDM-OB] Reveal !');
      done = true;

      /* Flash */
      flash.style.animation = 'cdmObFlash .9s ease forwards';

      setTimeout(function () {
        /* Cache capsule + hint */
        capsuleWrap.style.transition = 'opacity .3s, transform .3s';
        capsuleWrap.style.opacity = '0';
        capsuleWrap.style.transform = 'scale(.5)';
        hint.style.transition = 'opacity .25s';
        hint.style.opacity = '0';

        /* Affiche reveal */
        reveal.style.display = 'flex';
        flag.innerHTML = FLAGS[team.name] || '';
        countryName.textContent = team.label;

        var mascotUrl =
          (window.CDM_CONFIG && window.CDM_CONFIG.countryAssets && window.CDM_CONFIG.countryAssets[team.id] && window.CDM_CONFIG.countryAssets[team.id].mascotUrl) ||
          (window.CDM_CONFIG && window.CDM_CONFIG.mascotUrls && window.CDM_CONFIG.mascotUrls[team.id]) ||
          '';
        if (mascotUrl) mascot.src = mascotUrl;
        else mascot.style.display = 'none';

        spawnConfetti();
      }, 450);
    }

    function handleClick() {
      if (busy || done) return;
      clicks++;
      busy = true;
      console.log('[CDM-OB] Clic', clicks, '/4');

      /* Active la pip */
      if (pips[clicks - 1]) {
        pips[clicks - 1].style.background = '#7a4500';
        pips[clicks - 1].style.boxShadow = '0 0 10px rgba(122,69,0,.5)';
      }

      /* Shake */
      capsuleInner.style.animation = 'none';
      void capsuleInner.offsetWidth;
      capsuleInner.style.animation = 'cdmObShake ' + (0.3 + clicks * 0.06).toFixed(2) + 's ease';

      if (clicks >= 4) {
        setTimeout(doReveal, 350);
      } else {
        setTimeout(function () { busy = false; }, 320);
      }
    }

    capsuleWrap.addEventListener('click', handleClick);
    capsuleWrap.addEventListener('touchstart', function (e) {
      e.preventDefault();
      handleClick();
    }, { passive: false });

    skip.addEventListener('click', complete);
    cta.addEventListener('click', complete);
  }

  /* ══════════════════════════════════════════
     POINT D'ENTRÉE
  ══════════════════════════════════════════ */
  function initOnboarding(opts) {
    opts = opts || {};
    var onComplete = opts.onComplete;
    console.log('[CDM-OB] initOnboarding appelé');

    var force = location.search.indexOf('booster=force') !== -1;
    var alreadyOnboarded = localStorage.getItem('cdm_onboarded') === '1';

    if (!force && alreadyOnboarded) {
      console.log('[CDM-OB] Déjà onboardé, skip');
      if (typeof onComplete === 'function') onComplete();
      return;
    }

    injectKeyframes();

    /* URLs des assets */
    var cfg = window.CDM_CONFIG || {};
    var lobby = cfg.lobbyAssets || {};
    var capsuleUrl  = lobby.capsule  || '';
    var unlockBgUrl = lobby.unlockBg || '';

    console.log('[CDM-OB] capsule URL :', capsuleUrl || '⚠ MANQUANT');

    /* Choix de l'équipe */
    var savedId = localStorage.getItem('cdm_team');
    var team = null;
    if (savedId) {
      for (var i = 0; i < TEAMS.length; i++) {
        if (TEAMS[i].id === savedId) { team = TEAMS[i]; break; }
      }
    }
    if (!team) {
      team = TEAMS[Math.floor(Math.random() * TEAMS.length)];
      try { localStorage.setItem('cdm_team', team.id); } catch (_) {}
    }
    console.log('[CDM-OB] Équipe choisie :', team.id);

    /* Étape 1 : Formulaire */
    createForm(function () {
      /* Étape 2 : Booster */
      createBooster(team, capsuleUrl, unlockBgUrl, function (teamId) {
        console.log('[CDM-OB] onComplete avec teamId =', teamId);
        if (typeof onComplete === 'function') onComplete(teamId);
      });
    });
  }

  /* ══════════════════════════════════════════
     RUN BOOSTER — lance directement l'animation booster
     pour une équipe précise, sans formulaire (utilisé par le shop / vestiaire)
  ══════════════════════════════════════════ */
  function runBooster(teamId, onComplete) {
    console.log('[CDM-OB] runBooster pour', teamId);
    injectKeyframes();

    var team = null;
    for (var i = 0; i < TEAMS.length; i++) {
      if (TEAMS[i].id === teamId) { team = TEAMS[i]; break; }
    }
    if (!team) {
      console.warn('[CDM-OB] Équipe introuvable :', teamId);
      if (typeof onComplete === 'function') onComplete();
      return;
    }

    var cfg = window.CDM_CONFIG || {};
    var lobby = cfg.lobbyAssets || {};
    var capsuleUrl  = lobby.capsule  || '';
    var unlockBgUrl = lobby.unlockBg || '';

    createBooster(team, capsuleUrl, unlockBgUrl, function (id) {
      if (typeof window.cdmUnlockTeam === 'function') window.cdmUnlockTeam(id);
      if (typeof onComplete === 'function') onComplete(id);
    });
  }

  /* ── Exposition globale ── */
  window.cdmOnboarding = initOnboarding;
  window.cdmRunBooster = runBooster;
  console.log('[CDM-OB] window.cdmOnboarding + cdmRunBooster définis');
})();
